export function booleanString(value: boolean) {
	return new Boolean(value).toString()
}
